/* eslint-disable radix */
import React, { useEffect, useState } from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import VideoPlaylistItem from '../videoPlaylistItem/VideoPlaylistItem';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      background: '#F5F5F5',
      borderRadius: '5px',
      cursor: 'pointer',
      display: 'inline-block',
      marginBottom: '0px',
      marginRight: '11px',
      padding: '6px ',
      width: '112px',
      [theme.breakpoints.up('lg')]: {
        display: 'block',
      },
    },
    listContainer: {
      display: 'block',
      overflow: 'auto',
      paddingBottom: '1rem',
      paddingRight: '0px',
      textAlign: 'left',
      whiteSpace: 'noWrap',
      [theme.breakpoints.up('lg')]: {
        maxHeight: '230px',
        maxWidth: 'none',
        paddingBottom: '0px',
        paddingRight: '20px',
        whiteSpace: 'normal',
      },
    },
    selected: {
      background: `${theme.palette.primary.main}11`,
      border: `2px solid ${theme.palette.primary.main}AA`,
    },
    title: {
      color: '#172B4D',
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '24px',
      marginBottom: '9px',
      textAlign: 'left',
    },
    [theme.breakpoints.up('lg')]: {
      container: {
        marginBottom: '10px',
        marginRight: '0px',
        maxWidth: '350px',
        padding: '10px',
        width: 'auto',
      },
      title: {
        marginBottom: '15px',
      },
    },
  };
});

export default ({ videos, onSelect }) => {
  const classes = useStyles();
  const [videoItems, setVideoItems] = useState(videos);
  useEffect(() => {
    setVideoItems(videos);
  }, [videos]);

  const renderVideos = videoItems.map((video, index) => (
    <div aria-hidden="true" className={`${classes.container} ${video.isPlaying ? classes.selected : ''}`} onClick={() => onSelect(video)} key={video.url}>
      <VideoPlaylistItem thumbnail={video.thumbnail} title={video.title} index={index + 1} isPlaying={video.isPlaying} />
    </div>
  ));

  return (
    <div>
      <Typography className={classes.title}>Education Playlist</Typography>
      <div className={classes.listContainer}>{renderVideos}</div>
    </div>
  );
};
